import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import { SOFTLINE_API_GARAGE_VEHICLE_MILEAGE } from '../garage.api';
import { MileageHistory } from '../models/milage-history';
import { AddMileageBody } from '../models/vehicle';

@Injectable()
export class MileageHistoryRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  retrieveById(id: number): Promise<MileageHistory[]> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_VEHICLE_MILEAGE, { id })
    );
  }

  async addMileage(vehicleId: string, body: AddMileageBody): Promise<MileageHistory> {
    return await this.#dataAccess.create(
      {
        path: SOFTLINE_API_GARAGE_VEHICLE_MILEAGE,
        pathParams: {
          id: vehicleId,
        },
      },
      body
    );
  }
}
